import React from "react";

const DynamicBilling = () => {
  return <div></div>;
};

export default DynamicBilling;
